import { IANATimezones } from '@gcv/shared';

export const IANATimezoneOptions: { label: IANATimezones; value: IANATimezones }[] = Object.values(
  IANATimezones
).map((timezone) => {
  return { label: timezone, value: timezone };
});
